export const BILLING_HISTORY_REDUCER_NAME = 'billingHistory'
export const GET_BILLING_CHARGES_REDUCER_NAME = 'getBillingCharges'
export const BILLING_CHARGES_LIST_REDUCER_NAME = 'billingChargesList'

export enum BILLING_HISTORY_HEADERS {
  DATE = 'date',
  HOME_NAME = 'homeName',
  DESCRIPTION = 'description',
  PAYMENT_METHOD = 'paymentMethod',
  AMOUNT = 'amount',
  STATUS = 'status',
}
